// @ts-strict-ignore
import { useAccountsContext } from 'hooks/context/useAccountsContext'
import { CustomerModel } from 'pages/Customers/helpers/types'
import { isCryptoCustomerWallet } from 'pages/Customers/helpers/utils'
import { MovePayload } from 'pages/NestedCustomers/types'
import { SourceWallet } from 'types/move/move'
import {
  checkIsCustomerWalletTransferType,
  checkIsEmbeddedOrRelianceModel,
  checkIsPrincipalWallet,
  checkIsTransferTypeSelected,
  checkIsWalletTransferTypeEnabled,
  checkRequiresCustomerReference,
  checkShowContent,
} from '../utils/utils'

interface UseMoveFormConditionsProps {
  sourceWallet: SourceWallet | null
  customerModel?: CustomerModel
  hasTransferWallets: boolean
  isLoading: boolean
  formValues: MovePayload
  isInsufficientBalance: boolean
  isExceedingMaxAmount: boolean
}

export const useMoveFormConditions = ({
  sourceWallet,
  customerModel,
  hasTransferWallets,
  isLoading,
  formValues,
  isInsufficientBalance,
  isExceedingMaxAmount,
}: UseMoveFormConditionsProps) => {
  const { accountCapabilities } = useAccountsContext()
  const { isEpcWalletInternalTransfersCapabilityEnabled } = accountCapabilities || {}

  const isCryptoWallet = isCryptoCustomerWallet(sourceWallet?.currency)
  const isPrincipalWallet = checkIsPrincipalWallet(sourceWallet?.walletType)
  const isEmbeddedOrRelianceCustomerModel = checkIsEmbeddedOrRelianceModel(customerModel)
  const isCustomerWalletTransferType = checkIsCustomerWalletTransferType(
    formValues?.walletTransferType
  )

  const isWalletTransferTypeEnabled = checkIsWalletTransferTypeEnabled({
    isEmbeddedOrRelianceModel: isEmbeddedOrRelianceCustomerModel,
    isPrincipalWallet,
    isCryptoWallet,
    isEpcCapabilityEnabled: isEpcWalletInternalTransfersCapabilityEnabled,
  })

  const customerHasNoModel = !customerModel

  const isTransferTypeSelected = checkIsTransferTypeSelected(formValues?.walletTransferType)
  const requiresCustomerReference = checkRequiresCustomerReference({
    isCustomerWalletTransferType,
    customerReference: formValues?.customerReference,
  })

  const showContent = checkShowContent({
    hasTransferWallets,
    destinationWallet: formValues?.destinationWallet,
    isTransferTypeSelected,
    requiresCustomerReference,
  })

  const isDisabled = isLoading || isInsufficientBalance || isExceedingMaxAmount

  return {
    isEmbeddedOrRelianceCustomerModel,
    isCustomerWalletTransferType,
    isWalletTransferTypeEnabled,
    customerHasNoModel,
    isTransferTypeSelected,
    requiresCustomerReference,
    showContent,
    isDisabled,
  }
}
